import { Box, Icon, Text } from '@medely/ui-kit';
import { HideFrom } from '@mp/components/HideFrom';
import React from 'react';
import { CancelationPolicy } from '../../CancelationPolicy';
import { JobDetailsListItem } from '../../JobDetailsListItem';
import { CancelShiftButton } from './CancelShiftButton';
import { UtmParamsType } from './interface';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { JobDetailsFragment } from '../graphql';
import moment from 'moment';

export const shouldShowJobCancelationPolicy = (
  status?: string | null,
  currentStartsTime?: string | null,
): boolean => {
  if (['clocked_in', 'clocked_out'].includes(status ?? '')) {
    return false;
  }

  if (!['active', 'booked'].includes(status ?? '')) {
    return false;
  }
  if (moment.utc(currentStartsTime).isBefore(moment.utc())) {
    return false;
  }

  return true;
};

type JobCancelationPolicyProps = {
  job?: FragmentType<typeof JobDetailsFragment> | null;
  bookedOrInProgressOrCompleted: boolean;
  smallIcon?: boolean;
  utmParams?: UtmParamsType;
};

export const JobCancelationPolicy = ({
  job: inputJob,
  bookedOrInProgressOrCompleted,
  smallIcon = false,
  utmParams,
}: JobCancelationPolicyProps) => {
  const job = parseFragmentData(JobDetailsFragment, inputJob);

  const isCompany21779 = job?.location?.company_id === 21779;
  const cancellationProtectionInfoText = isCompany21779
    ? `If the facility cancels within ${job?.cancellation_fee_window} hours of the start time, a $40 cancellation fee will be paid.`
    : `If the facility cancels within ${job?.cancellation_fee_window} hours of the start time, a ${job?.cancellation_fee_charge_hours}-hour cancellation fee will be paid.`;

  return (
    <Box my={2}>
      <HideFrom saas>
        <CancelationPolicy />
      </HideFrom>

      {/* Show cancel button only for booked jobs */}
      {bookedOrInProgressOrCompleted && (
        <>
          <Box>
            <CancelShiftButton job={inputJob} utmParams={utmParams} />
          </Box>
          <Box pt={2}>
            <HideFrom agency saas>
              <JobDetailsListItem
                title="Cancellation Protection"
                icon={
                  <Icon
                    name="light-shield-check"
                    iconSize={smallIcon ? '14px' : '20px'}
                    color="text.primary"
                    variant="custom"
                  />
                }
              >
                <Text size="m" color="text.secondary">
                  {cancellationProtectionInfoText}
                </Text>
              </JobDetailsListItem>
            </HideFrom>
          </Box>
        </>
      )}
    </Box>
  );
};
